customElements.define(
  "related-products-cart-form",
  class RelatedProductsCartForm extends HTMLElement {
    constructor() {
      super();

      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="button"]');
      this.submitButtonText = this.submitButton.querySelector("span");

      if (document.querySelector("cart-drawer"))
        this.submitButton.setAttribute("aria-haspopup", "dialog");

      this.hideErrors = this.dataset.hideErrors === "true";

      this.querySelectorAll("button").forEach((product) => {
        product.addEventListener("click", (evt) => {
          this.onSubmitHandler(evt, product);
        });
      });
    }

    onSubmitHandler(evt, product) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      this.querySelector(".loading__spinner").classList.remove("hidden");

      let formData = {
        items: [
          {
            id: product.id,
          },
        ],
      };

      if (this.cart) {
        formData.sections = this.cart
          .getSectionsToRender()
          .map((section) => section.id);
        formData.sections_url = window.location.pathname;
      }

      const url = this.getAttribute("data-cart-api");
      fetch(`${url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response && response.items.length > 0) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "related-products-cart-form",
              productVariantId: formData.items[0].id,
            });

            this.submitButton.setAttribute("aria-disabled", true);
            this.error = true;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const parser = new DOMParser();
          const cartDrawerFromApiResponse = parser
            .parseFromString(response.sections["cart-drawer"], "text/html")
            .querySelector("#CartDrawer");
          const cartDrawer = document.querySelector("cart-drawer");
          cartDrawer.replaceChildren(cartDrawerFromApiResponse);

          const cartIconBubbleFromApiResponse = parser
            .parseFromString(
              response.sections["cart-icon-bubble"],
              "text/html",
            )
            .getElementById("shopify-section-cart-icon-bubble");
          const cartIconBubble =
            document.getElementById("cart-icon-bubble");
          cartIconBubble.replaceChildren(cartIconBubbleFromApiResponse);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    get variantIdInput() {
      return this.form.querySelector("[name=id]");
    }
  },
);